module.exports = __webpack_public_path__ + "media/img/help_center/Student_Test_06-df28d17c882baf5ffb78d5b780b27890.jpg";